import script from "./FocusedLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./FocusedLayout.vue?vue&type=script&setup=true&lang=ts"

import "./FocusedLayout.vue?vue&type=style&index=0&id=5d0c85e5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d0c85e5"]])

export default __exports__